<div class="h-25 bg-yellow-300 flex flex-col items-center justify-center font-bold">
  <div class="text-3xl mb-2">Time Left to Register</div>
  <div class="flex items-center h-10 mt-2">
    <div class="flex flex-col lg:flex-row items-center pr-1 lg:pr-3">
      <div class="flex">
        <div class="relative bg-white h-full text-yellow-300 clock-number">
          {{ (dayDigits$ | async)?.tens }}
        </div>
        <div class="relative bg-white h-full text-yellow-300 clock-number">
          {{ (dayDigits$ | async)?.ones }}
        </div>
      </div>
      <div class="uppercase">days</div>
    </div>
    <div class="flex flex-col lg:flex-row items-center pr-1 lg:pr-3">
      <div class="flex">
        <div class="relative bg-white h-full text-yellow-300 clock-number">
          {{ (hourDigits$ | async)?.tens }}
        </div>
        <div class="relative bg-white h-full text-yellow-300 clock-number">
          {{ (hourDigits$ | async)?.ones }}
        </div>
      </div>
      <div class="uppercase">hours</div>
    </div>
    <div class="flex flex-col lg:flex-row items-center pr-1 lg:pr-3">
      <div class="flex">
        <div class="relative bg-white h-full text-yellow-300 clock-number">
          {{ (minuteDigits$ | async)?.tens }}
        </div>
        <div class="relative bg-white h-full text-yellow-300 clock-number">
          {{ (minuteDigits$ | async)?.ones }}
        </div>
      </div>
      <div class="uppercase">minutes</div>
    </div>
    <div class="flex flex-col lg:flex-row items-center">
      <div class="flex">
        <div class="relative bg-white h-full text-yellow-300 clock-number">
          {{ (secondDigits$ | async)?.tens }}
        </div>
        <div class="relative bg-white h-full text-yellow-300 clock-number">
          {{ (secondDigits$ | async)?.ones }}
        </div>
      </div>
      <div class="uppercase">seconds</div>
    </div>
  </div>
  <div class="mt-3">Registration Closes {{ registrationEndsAt$ | async | standardDate }}!</div>
</div>
